module.exports = __webpack_public_path__ + "img/ignatian-meditations.27b550a8.jpg";